import React from "react";
import { DA_Icon, DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { useTranslations } from "../../../contexts/translations/translations.context";
import S from "./SwipeOrRotate.module.scss";

export const DA_SwipeOrRotate = () => {
    const { getDictionaryItem } = useTranslations();

    return (
        <div className={S.wrapper}>
            <div>
                {getDictionaryItem("swipeToSeeMoreColumns")}
                <DA_Icon name={DA_IconNames.ScrollHorizontal} className={S.icon} />
            </div>
            <div>
                {getDictionaryItem("rotateToSeeMore")}
                <DA_Icon name={DA_IconNames.RotateDevice} className={S.icon} />
            </div>
        </div>
    );
};
